"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nnShareSnapShot = nnShareSnapShot;
const tslib_1 = require("tslib");
const tool_nn_1 = tslib_1.__importDefault(require("@futuweb/tool-nn"));
const nnq_1 = tslib_1.__importDefault(require("@futuweb/tool-nn/dist/nnq"));
const report_1 = require("./report");
let supportShareV3 = false;
if (nnq_1.default.isSupportShareV3()) {
    nnq_1.default.initBridge({}, () => {
        supportShareV3 = true;
    });
}
const pageName = location.pathname;
/**
 * 牛牛分享快照
 * @param dataUrl 分享图片的base64数据
 * @param opt 分享文案配置
 * @param opt.title 分享标题
 * @param opt.desc 分享描述
 * @param opt.link 分享链接
 * @param opt.image 分享图片
 * @param success
 * @param fail
 */
async function nnShareSnapShot(dataUrl, opt = {
    title: '',
    desc: '',
    link: '',
    image: '',
    isPriorityStructuredShare: false,
    reportAttrs: {
        element_id: '',
        element_name: ''
    }
}, success = (...args) => {
    console.log('分享成功', ...args);
}, fail = () => { }) {
    var _a;
    const hasConfigShow = Boolean(opt.title) && Boolean(opt.desc) && Boolean(opt.link) && Boolean(opt.image);
    // configSnapshot安卓客户端后续不进行维护
    // 优先使用showDiverseShare方法
    const protoShareType = opt.isPriorityStructuredShare ? 6 : 7;
    const { element_id, element_name } = opt.reportAttrs;
    const { ftReport } = (_a = window.FEGORender) === null || _a === void 0 ? void 0 : _a.plugins;
    const pageId = ftReport.getFtReport().getPageId();
    const sessionInfo = JSON.stringify(ftReport.getFtReport().getSessionInfo());
    if (supportShareV3) {
        nnq_1.default.showDiverseShare({
            show_type: hasConfigShow ? protoShareType : 3,
            // share_data为必传的占位数据
            disable_channel: ['nnq', 'niuyou', 'chatRoom'],
            enable_channel: [],
            share_data: {
                common_model: {
                    title: opt.title || '',
                    description: opt.desc || '',
                    url: opt.link || '',
                    image_url: opt.image || 'https://static.futunn.com/futuhk_common/images/favicon.ico',
                    share_model_list: []
                }
            },
            share_image: {
                images: [
                    {
                        img: dataUrl
                    }
                ]
            }
        }, function (res = { channel: '' }) {
            const { channel } = res;
            (0, report_1.reportFtEvent)('Share', {
                page_name: pageName,
                channel_name: report_1.CHANNEL_MAP[channel] ? report_1.CHANNEL_MAP[channel] : '404' // 属性值如果为空，上报会异常
            }, 10);
            (0, report_1.reportFtEvent)('ShareFego', {
                page_id: pageId,
                session_info: sessionInfo,
                share_type: '2',
                $element_id: element_id || '',
                $element_name: element_name || '',
                channel_name: report_1.ShareFegoEventChannel[channel] || 'more'
            }, 1);
        }, fail);
    }
    else {
        // 配置分享快照
        tool_nn_1.default.configSnapshot({
            type: 'base64',
            data: dataUrl,
            success(res = { channel: '' }) {
                const { channel } = res;
                (0, report_1.reportFtEvent)('Share', {
                    page_name: pageName,
                    channel_name: report_1.CHANNEL_MAP[channel] ? report_1.CHANNEL_MAP[channel] : '404' // 属性值如果为空，上报会异常
                }, 10);
                (0, report_1.reportFtEvent)('ShareFego', {
                    page_id: pageId,
                    session_info: sessionInfo,
                    share_type: '2',
                    $element_id: element_id || '',
                    $element_name: element_name || '',
                    channel_name: report_1.ShareFegoEventChannel[channel] || 'more'
                }, 1);
                success(res);
            },
            fail
        });
        setTimeout(() => {
            tool_nn_1.default.showSnapshotShare(opt);
        }, 3000);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzaGFyZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQXVCQSwwQ0FnSEM7O0FBdklELHVFQUFrQztBQUNsQyw0RUFBNEM7QUFFNUMscUNBQTZFO0FBQzdFLElBQUksY0FBYyxHQUFHLEtBQUssQ0FBQztBQUMzQixJQUFJLGFBQUcsQ0FBQyxnQkFBZ0IsRUFBRSxFQUFFLENBQUM7SUFDekIsYUFBRyxDQUFDLFVBQVUsQ0FBQyxFQUFFLEVBQUUsR0FBRyxFQUFFO1FBQ3BCLGNBQWMsR0FBRyxJQUFJLENBQUM7SUFDMUIsQ0FBQyxDQUFDLENBQUM7QUFDUCxDQUFDO0FBQ0QsTUFBTSxRQUFRLEdBQUcsUUFBUSxDQUFDLFFBQVEsQ0FBQztBQUVuQzs7Ozs7Ozs7OztHQVVHO0FBQ0ksS0FBSyxVQUFVLGVBQWUsQ0FDakMsT0FBZSxFQUNmLEdBQUcsR0FBRztJQUNGLEtBQUssRUFBRSxFQUFFO0lBQ1QsSUFBSSxFQUFFLEVBQUU7SUFDUixJQUFJLEVBQUUsRUFBRTtJQUNSLEtBQUssRUFBRSxFQUFFO0lBQ1QseUJBQXlCLEVBQUUsS0FBSztJQUNoQyxXQUFXLEVBQUU7UUFDVCxVQUFVLEVBQUUsRUFBRTtRQUNkLFlBQVksRUFBRSxFQUFFO0tBQ25CO0NBQ0osRUFDRCxVQUFVLENBQUMsR0FBRyxJQUFXLEVBQUUsRUFBRTtJQUN6QixPQUFPLENBQUMsR0FBRyxDQUFDLE1BQU0sRUFBRSxHQUFHLElBQUksQ0FBQyxDQUFDO0FBQ2pDLENBQUMsRUFDRCxJQUFJLEdBQUcsR0FBRyxFQUFFLEdBQUUsQ0FBQzs7SUFFZixNQUFNLGFBQWEsR0FBRyxPQUFPLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxJQUFJLE9BQU8sQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLElBQUksT0FBTyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ3pHLDZCQUE2QjtJQUM3Qix5QkFBeUI7SUFFekIsTUFBTSxjQUFjLEdBQUcsR0FBRyxDQUFDLHlCQUF5QixDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztJQUM3RCxNQUFNLEVBQUUsVUFBVSxFQUFFLFlBQVksRUFBRSxHQUFHLEdBQUcsQ0FBQyxXQUFXLENBQUM7SUFDckQsTUFBTSxFQUFFLFFBQVEsRUFBRSxHQUFHLE1BQUMsTUFBYyxDQUFDLFVBQVUsMENBQUUsT0FBTyxDQUFDO0lBQ3pELE1BQU0sTUFBTSxHQUFHLFFBQVEsQ0FBQyxXQUFXLEVBQUUsQ0FBQyxTQUFTLEVBQUUsQ0FBQztJQUNsRCxNQUFNLFdBQVcsR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxXQUFXLEVBQUUsQ0FBQyxjQUFjLEVBQUUsQ0FBQyxDQUFDO0lBQzVFLElBQUksY0FBYyxFQUFFLENBQUM7UUFDakIsYUFBRyxDQUFDLGdCQUFnQixDQUNoQjtZQUNJLFNBQVMsRUFBRSxhQUFhLENBQUMsQ0FBQyxDQUFDLGNBQWMsQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUM3QyxxQkFBcUI7WUFDckIsZUFBZSxFQUFFLENBQUMsS0FBSyxFQUFFLFFBQVEsRUFBRSxVQUFVLENBQUM7WUFDOUMsY0FBYyxFQUFFLEVBQUU7WUFDbEIsVUFBVSxFQUFFO2dCQUNSLFlBQVksRUFBRTtvQkFDVixLQUFLLEVBQUUsR0FBRyxDQUFDLEtBQUssSUFBSSxFQUFFO29CQUN0QixXQUFXLEVBQUUsR0FBRyxDQUFDLElBQUksSUFBSSxFQUFFO29CQUMzQixHQUFHLEVBQUUsR0FBRyxDQUFDLElBQUksSUFBSSxFQUFFO29CQUNuQixTQUFTLEVBQUUsR0FBRyxDQUFDLEtBQUssSUFBSSw0REFBNEQ7b0JBQ3BGLGdCQUFnQixFQUFFLEVBQUU7aUJBQ3ZCO2FBQ0o7WUFDRCxXQUFXLEVBQUU7Z0JBQ1QsTUFBTSxFQUFFO29CQUNKO3dCQUNJLEdBQUcsRUFBRSxPQUFPO3FCQUNmO2lCQUNKO2FBQ0o7U0FDSixFQUNELFVBQVUsR0FBRyxHQUFHLEVBQUUsT0FBTyxFQUFFLEVBQUUsRUFBRTtZQUMzQixNQUFNLEVBQUUsT0FBTyxFQUFFLEdBQUcsR0FBRyxDQUFDO1lBQ3hCLElBQUEsc0JBQWEsRUFDVCxPQUFPLEVBQ1A7Z0JBQ0ksU0FBUyxFQUFFLFFBQVE7Z0JBQ25CLFlBQVksRUFBRSxvQkFBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxvQkFBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsZ0JBQWdCO2FBQ3JGLEVBQ0QsRUFBRSxDQUNMLENBQUM7WUFDRixJQUFBLHNCQUFhLEVBQ1QsV0FBVyxFQUNYO2dCQUNJLE9BQU8sRUFBRSxNQUFNO2dCQUNmLFlBQVksRUFBRSxXQUFXO2dCQUN6QixVQUFVLEVBQUUsR0FBRztnQkFDZixXQUFXLEVBQUUsVUFBVSxJQUFJLEVBQUU7Z0JBQzdCLGFBQWEsRUFBRSxZQUFZLElBQUksRUFBRTtnQkFDakMsWUFBWSxFQUFFLDhCQUFxQixDQUFDLE9BQU8sQ0FBQyxJQUFJLE1BQU07YUFDekQsRUFDRCxDQUFDLENBQ0osQ0FBQztRQUNOLENBQUMsRUFDRCxJQUFJLENBQ1AsQ0FBQztJQUNOLENBQUM7U0FBTSxDQUFDO1FBQ0osU0FBUztRQUNULGlCQUFFLENBQUMsY0FBYyxDQUFDO1lBQ2QsSUFBSSxFQUFFLFFBQVE7WUFDZCxJQUFJLEVBQUUsT0FBTztZQUNiLE9BQU8sQ0FBQyxHQUFHLEdBQUcsRUFBRSxPQUFPLEVBQUUsRUFBRSxFQUFFO2dCQUN6QixNQUFNLEVBQUUsT0FBTyxFQUFFLEdBQUcsR0FBRyxDQUFDO2dCQUN4QixJQUFBLHNCQUFhLEVBQ1QsT0FBTyxFQUNQO29CQUNJLFNBQVMsRUFBRSxRQUFRO29CQUNuQixZQUFZLEVBQUUsb0JBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUMsb0JBQVcsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLGdCQUFnQjtpQkFDckYsRUFDRCxFQUFFLENBQ0wsQ0FBQztnQkFDRixJQUFBLHNCQUFhLEVBQ1QsV0FBVyxFQUNYO29CQUNJLE9BQU8sRUFBRSxNQUFNO29CQUNmLFlBQVksRUFBRSxXQUFXO29CQUN6QixVQUFVLEVBQUUsR0FBRztvQkFDZixXQUFXLEVBQUUsVUFBVSxJQUFJLEVBQUU7b0JBQzdCLGFBQWEsRUFBRSxZQUFZLElBQUksRUFBRTtvQkFDakMsWUFBWSxFQUFFLDhCQUFxQixDQUFDLE9BQU8sQ0FBQyxJQUFJLE1BQU07aUJBQ3pELEVBQ0QsQ0FBQyxDQUNKLENBQUM7Z0JBQ0YsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1lBQ2pCLENBQUM7WUFDRCxJQUFJO1NBQ1AsQ0FBQyxDQUFDO1FBRUgsVUFBVSxDQUFDLEdBQUcsRUFBRTtZQUNaLGlCQUFFLENBQUMsaUJBQWlCLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDOUIsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDO0lBQ2IsQ0FBQztBQUNMLENBQUMifQ==